import React, {useContext} from 'react';
import './Viewport.scss';
import Logo from "../Logo/Logo";
import SpinWheel from "../SpinWheel/SpinWheel";
import Results from "../Results/Results";
import Background from "../Background/Background";
import {Context} from "../../App";
import Utils from "../../utils/Utils";

function Viewport() {
  const context = useContext(Context);
  const isClassicMode = context.gameMode.get === Utils.STW_CLASSIC;

  return <div className='viewport-container'>
    <Logo isClassicMode={isClassicMode}/>
    <SpinWheel isClassicMode={isClassicMode}/>
    <Results isClassicMode={isClassicMode}/>
    <Background isClassicMode={isClassicMode}/>
  </div>
}

export default Viewport;